export default "__VITE_ASSET__c1508abc__"